export const all = state => state.all;
export const parsed = (state) => {
  const stateAll = JSON.parse(JSON.stringify(state.all));

  stateAll.map((el) => {
    if (el.date) {
      const date = el.date.split('.');
      el.parsedDate = new Date(date[2], date[1], date[0]);
      if (el.toDate) {
        const toDate = el.toDate.split('.');
        el.parsedToDate = new Date(toDate[2], toDate[1], toDate[0]);
      } else {
        el.parsedToDate = el.toDate;
      }
      return el;
    }
    return '';
  });

  return stateAll;
};
